export const FORTO_AVATAR = 'forto-avatar'
export const INITIALS_AVATAR = 'initials-avatar'
export const THUMBNAIL_AVATAR = 'thumbnailUrl-avatar'
export type TAvatarType = 'forto-avatar' | 'initials-avatar' | 'thumbnailUrl-avatar'
